import { DomainRegistry } from "../../../../../domain";
import { FormatTreeSourceBase } from "./FormatTreeSourceBase";

export class FormatTreeSource extends FormatTreeSourceBase {
  constructor() {
    super("フォーマット情報", () => DomainRegistry.instance.editableFormat.getFormatRepository());
  }
}
